// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2akUE","content":"ManualTimeModal_content__3Zcic"};